'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _themeLocalStorage = require('../helpers/theme-local-storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function (event) {
  /*-------------------------------
  Modal Auto Show
  -------------------------------*/
  // Capture all of the modals.
  var modals = document.querySelectorAll('.modal');

  // Get the themes local storage data.
  var themeLocalStorage = (0, _themeLocalStorage.getThemeLocalStorage)('viewedModals');

  [].concat((0, _toConsumableArray3.default)(modals)).forEach(function (modal) {
    // Modal settings
    var modalId = modal.id;
    var autoShowModal = modal.dataset.autoShowEnabled === 'true' ? true : false;
    var autoShowTime = Number(modal.dataset.autoShowTime) * 1000;
    var viewedModal = themeLocalStorage.viewedModals.includes(modalId);

    // If the modal is set to auto show via the dashboard and the user hasn't viewed the modal yet then show it.
    if (autoShowModal && !viewedModal) {
      // Show after a few seconds.
      window.setTimeout(function () {
        // Show Modal
        window.MicroModal.show(modalId, {
          awaitCloseAnimation: true
        });

        // Indicate that the user has viewed this modal
        themeLocalStorage.viewedModals.push(modalId);

        // Set the data back in localStorage so we can access it later.
        (0, _themeLocalStorage.setThemeLocalStorage)(themeLocalStorage);
      }, autoShowTime);
    }
  });
}); /*-------------------------------
    Imports
    -------------------------------*/